import { useRef } from "react";

import Grid from '@material-ui/core/Grid';
import CardIcon from '@material-ui/icons/LibraryBooks';
import Toast from '@base/Toast'
import Table from '@base/Table';

import ObjetoPostalService from "@services/ObjetoPostalService";

export const OutrosDocumentosObjetoPostalTableView = (props) => {
	const processo = props.processo;
	const documentos = props.documentos;
	const toastRef = useRef(null);
	const columnsDocumentos = [
		{ label: 'Documento', name: 'token', func: (a) => a ? a.substring(0,20) : "", key: true, ordering: false },
	];

	function downloadArquivo(id) {
		ObjetoPostalService.visualizarOutrosDocumentos(processo, id).then(resultado => {
				const file = resultado.data.type.includes('image') ? resultado.data : new Blob([resultado.data], { type: resultado.data.type });
				const fileURL = URL.createObjectURL(file);
				window.open(fileURL, '_blank');
		}).catch(erro => {
			toastRef.current.show("error","Não foi posível fazer download do arquivo.");
		});
	}

	const actionsDocumentos = [
		{
			func: (token,obj) => {
				downloadArquivo(obj.id);
			} ,
			icon: <CardIcon />,
			disabled: (token,obj) =>  false,
			name: (token,obj) => "Visualizar Digitalização"
		}
	];

	return (
		<>
			<Toast ref={toastRef} />
			<Grid container spacing={5}>
				<Grid item xs={12}>
					<Table style={{ marginTop: 0 }}
						columns={columnsDocumentos}
						tableData={documentos}
						actions={actionsDocumentos}
						loading={false}
					/>
				</Grid>
			</Grid>
		</>
	);
}

export default OutrosDocumentosObjetoPostalTableView;
